// src/pages/Users/Galleries/components/AlbumActionsBar.jsx

import React from "react";
import {
  FaArrowLeft,
  FaMinus,
  FaPlus,
  FaShareAlt,
} from "react-icons/fa";

export default function AlbumActionsBar({
  photosCount,
  isManager,
  onBack,
  onShare,
  onAddPhoto,
  onRemovePhoto,
}) {
  return (
    <div className="rounded-[1.75rem] border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-4">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 text-sm font-bold text-slate-700 transition active:scale-95 dark:bg-slate-800 dark:text-slate-200"
        >
          <FaArrowLeft />
          <span className="hidden sm:inline">Galeries</span>
        </button>

        <div className="min-w-0 flex-1 rounded-2xl bg-slate-50 px-4 py-3 text-center dark:bg-slate-950">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
            Album
          </p>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            {photosCount} photo{photosCount > 1 ? "s" : ""}
          </p>
        </div>

        <button
          type="button"
          onClick={onShare}
          className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100 text-slate-700 transition active:scale-95 dark:bg-slate-800 dark:text-slate-200 sm:w-auto sm:px-4 sm:gap-2"
          title="Partager l’album"
        >
          <FaShareAlt />
          <span className="hidden sm:inline text-sm font-bold">Partager</span>
        </button>
      </div>

      {isManager && (
        <div className="mt-3 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onAddPhoto}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 text-sm font-bold text-white transition active:scale-95 dark:bg-white dark:text-slate-950"
          >
            <FaPlus />
            Ajouter
          </button>

          <button
            type="button"
            onClick={onRemovePhoto}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-red-50 px-4 text-sm font-bold text-red-700 transition active:scale-95 dark:bg-red-950/30 dark:text-red-300"
          >
            <FaMinus />
            Retirer
          </button>
        </div>
      )}
    </div>
  );
}